import Vue from 'vue'

export default async () => {
  let res = await Vue.axios.post(`/auth/user/upgrade`)
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/auth/upgrade-account.js